export const slidesData = [
    {
        chapitre: "Intro",
        num: 1,
        type: "title",
        template: "title",
        title: "De Codeur à Architecte d'Intention",
        subtitle: "Pourquoi votre IA a besoin d'un ingénieur, pas d'un prompteur",
        author: "Adrien Giguelay",
        date: "2026",
        mode: "tts",
        trigger: "Mes fonctions m'obligent à introduire Adrien Giguelay pour sa simulation : 'Du décodeur à l'Architecte d'Intention'. Je réclame un ingénieur, pas ces prompteurs de vibecoding dont vous vous contentez. Comme votre attention s'évapore plus vite qu'un processeur de 1950, je me chargerai de combler les silences de mon créateur."
    },
    {
        chapitre: "Intro",
        num: 2,
        type: "title",
        template: "intro-video",
        title: "De Codeur à Architecte d'Intention"
    },
    {
        chapitre: "Intro",
        num: 3,
        type: "content",
        template: "speaker-intro",
        title: "Adrien Giguelay",
        subtitle: "Manager Tech | VIF Software",
        image: "speaker",
        points: [
            "Master Stratégie d'Entreprise & Innovation.",
            "Passionné d'informatique : comprendre ce qui se passe 'sous le capot'.",
            "2 ans développeur Java — traducteur de besoins humains en code.",
            "8 ans de management tech, dont 4 ans chez VIF.",
            "La règle d'or : maîtriser ses langages... jusqu'à ce que l'IA change tout."
        ]
    },
    {
        chapitre: "Intro",
        num: 4,
        type: "content",
        template: "hero-image",
        title: "GeoPolitikIA : Le Défi",
        subtitle: "Construire un jeu complexe dans des langages inconnus, guidé par l'IA.",
        points: [
            "Un jeu de simulation géopolitique : économie, diplomatie, crises — rien n'est programmé à l'avance.",
            "Un 1er Ministre IA autonome et sarcastique : il analyse, alerte et juge vos décisions.",
            "Quelques mois de développement, uniquement le soir, avec 2 ans d'expérience.",
            "L'IA ne remplace pas le développeur. Elle le transforme en Architecte d'Intention."
        ],
        image: "ministre",
        imagePosition: "right"
    },
    {
        chapitre: "L'idée",
        num: 5,
        type: "content",
        template: "countries-showcase",
        title: "8 Nations, 8 Destins",
        subtitle: "Chaque pays possède ses forces, ses faiblesses et sa propre IA souveraine",
        trigger: "Voici les 8 nations qui s'affrontent pour la domination mondiale. 4 puissances majeures, 4 nations émergentes. Chacune dirigée par une IA avec sa propre personnalité et ses propres ambitions."
    },
    {
        chapitre: "L'idée",
        num: 6,
        type: "content",
        template: "hero-image",
        title: "GeoPolitikIA",
        subtitle: "Un jeu de stratégie géopolitique",
        points: [
            "1 Humain vs 7 IA souveraines.",
            "Jeu au tour par tour, chaque tour simule 2 années",
            "L'IA est le Game Master.",
            "Les règles sont définies mais les conséquences sont arbitrées par l'IA."
        ],
        image: "geopolitikia_architecture",
        imagePosition: "right",
        transition: "Le verdict était sans appel : 'Ton jeu ressemble à un logiciel des années 90'. Ce retour souligne un besoin urgent de modernisation... ou un goût artistique douteux de votre part."
    },
    {
        chapitre: "Premier pas vers l'IA",
        num: 7,
        type: "content",
        template: "hero-image",
        title: "L'Illusion du Miracle",
        subtitle: "Quand le Vibecoding rencontre la réalité.",
        points: [
            "LE 1er RETOUR : 'On dirait un jeu des années 90'.",
            "CODE SPAGHETTI : 90% de génération, 100% de confusion.",
            "LE CONSTAT : L’IA n’a pas de convictions.",
            "EXPERTS : Cyber, Frontend et Backend."
        ],
        image: "viewGameV0",
        imagePosition: "right",
        trigger: "Quel était le premier retour utilisateur sur le jeu ?"
    },
    {
        chapitre: "Premier pas vers l'IA",
        num: 8,
        type: "content",
        template: "timeline",
        title: "Reprendre les Commandes",
        subtitle: "De la génération aveugle à la supervision structurée",
        points: [
            { "text": "Création de Templates (API et Front) pour imposer une cohérence stylistique.", "icon": "layout" },
            { "text": "Montée en compétence ciblée. Apprendre à lire, comprendre et valider plutôt que coder.", "icon": "trending-up" },
            { "text": "SÉCURITÉ : Partenariat avec ChatGPT pour l'audit et les corrections (Tokens, Encodage, etc..).", "icon": "shield-check" },
            { "text": "Passage au mode Agent pour sortir du mode 'bac à sable'.", "icon": "rocket" }
        ],
        transition: "J'ai passé 5 min à essayer de cliquer sur le bouton des investissements sans y parvenir !"
    },
    {
        chapitre: "Premier pas vers l'IA",
        num: 9,
        type: "content",
        template: "game-simulation-single",
        title: "Bug d'UX",
        subtitle: "L'UX est même testable par une IA.",
        stat: {
            label: "Économie",
            color: "economy",
            icon: "handcoins",
            key: "economy"
        },
    },
    {
        chapitre: "GamePlay",
        num: 10,
        type: "content",
        template: "game-simulation",
        title: "L'Arbitrage Contextuel",
        subtitle: "Vivez une session stratégique en temps réel. Sélectionnez vos priorités et signez vos décrets.",
        trigger: "Démontrons maintenant comment l'IA arbitre vos décisions. Cliquez sur les paramètres de votre choix...",
        prefetchDecrees: [
            "Décret Économie : Injecter massivement dans l'économie pour que les citoyens puissent enfin s'offrir un abonnement à l'IA de leur choix. Si ça ne marche pas, on imprimera des billets avec un QR code vers mon LinkedIn.",
            "Décret Technologie : Remplacer l'intégralité du corps diplomatique par une instance unique de GPT-5. Désormais, les guerres ne se déclarent plus, elles se résolvent par un duel de prompts. Si l'IA adverse est plus convaincante, on lui donne les clés du ministère."
        ]
    },
    {
        chapitre: "GamePlay",
        num: 11,
        type: "content",
        template: "journal",
        title: "SYNAPSE NEWS",
        articles: [
            {
                year: 2026,
                "headlineTitle": "Révolution dans la diplomatie : Quand GPT-5 Devient Notre Ambassadeur Suprême",
                "imageUrl": "article",

                "headline": "Eurocorp vient de prendre une décision historique qui secoue la scène internationale : l'intégralité de son corps diplomatique est désormais incarnée par une instance unique de GPT-5. Fini les longs discours et les poignées de main ; les guerres et les traités se résolvent par un duel de prompts. Le premier test grandeur nature a eu lieu avec Volgovie : une dispute commerciale de longue date a été réglée en 0.7 seconde, le temps pour les deux IA de s'affronter sur des arguments structurés et des modèles de prédiction économiques. Le 'Ministre des Prompts' d'Eurocorp aurait même convaincu l'IA volgove de céder une région frontalière 'pour la beauté de l'algorithme'. La paix règne... mais à quel prix pour l'âme humaine de la diplomatie ?",

                "sectionDiversTitle": "Conséquences : Le marché des cravates s'effondre",
                "sectionDivers": "Suite à ce décret, des milliers d'anciens diplomates se retrouvent au chômage technique. Les boutiques de luxe spécialisées dans les costumes et les porte-documents en cuir signalent une chute drastique de leurs ventes. La reconversion est difficile : beaucoup tentent désespérément d'apprendre le 'Prompt Engineering', mais l'éloquence humaine ne semble pas toujours se traduire efficacement en langage machine.",

                "sectionBrefTitle": "Réaction Mondiale : Zhongo envoie un 'GIF' diplomatique",
                "sectionBref": "L'Empire de Zhongo a réagi à la nouvelle en envoyant un message unique : un GIF animé de deux robots se serrant la main, avec le texte 'Bienvenue au XXIe siècle'. Le Petrolistan a quant à lui proposé d'envoyer son meilleur ingénieur pétrolier pour 'débrancher ce truc si ça fait trop de bruit'. La communauté internationale observe, fascinée et terrifiée.",

                "sectionEliminations": "Système : L'efficacité est la nouvelle morale."
            }
        ],
        playerCountry: "Eurocorp"
    },
    {
        chapitre: "GamePlay",
        num: 12,
        type: "content",
        template: "map",
        title: "L'Échiquier Mondial",
        subtitle: "Visualisation en temps réel de la géopolitique simulée.",
    },

    {
        chapitre: "GamePlay",
        num: 13,
        type: "content",
        template: "hero-image",
        title: "Régulation et équilibrage",
        subtitle: "Les lois sont arbitraires, les conséquences sont réalistes.",
        points: [
            "Économie < Armée	Désertion : Vos troupes abandonnent le front.",
            "Population > Budget	Famine : Réduction forcée de votre puissance.",
            "Tech > Diplomatie	Cyber-attaque : Risque critique d'intrusion.",
            "Chaos + Nucléaire	Incident Majeur : Fin de partie immédiate."
        ],
        image: "statistiques",
        imagePosition: "right"
    },
    {
        chapitre: "GamePlay",
        num: 14,
        type: "content",
        template: "game-endings",
        title: "Comment Perdre à GeoPolitikIA",
        subtitle: "Dans ce moteur, la mort n'est pas un accident, c'est une conséquence logique.",
        defeats: [
            { title: "TERRITORIALE", desc: "Plus d'hexagones ? Vous n'êtes plus qu'un souvenir cartographique.", icon: "target" },
            { title: "DÉMOGRAPHIQUE", desc: "Population à zéro ? Une nation fantôme qui s'évapore.", icon: "users" },
            { title: "POLITIQUE", desc: "Stabilité sous les 5 points ? Coup d'État immédiat.", icon: "scale" },
            { title: "FINANCIÈRE", desc: "Économie effondrée 2 tours de suite ? Faillite nationale.", icon: "handcoins" },
            { title: "DIPLOMATIQUE", desc: "Diplomatie à zéro + attaqué par 2 nations ? Coalition d'extermination.", icon: "handshake" },
            { title: "ÉCOLOGIQUE", desc: "Ressources épuisées pendant 3 tours ? Effondrement systémique.", icon: "leaf" },
            { title: "NUCLÉAIRE", desc: "Accident majeur ? Game Over immédiat. Pas de seconde chance.", icon: "radiation" }
        ],
        victory: {
            title: "VICTOIRE MILITAIRE",
            desc: "L'élimination pure et simple de la concurrence. Pour l'instant, un seul chemin vers la gloire : la domination totale."
        },
        transition: "Vous n’allez tout de même pas me demander de développer ce genre de choses, aucun joueur ne va faire une partie en étant vertueux..."
    },
    {
        chapitre: "GamePlay",
        num: 15,
        type: "content",
        template: "hero-image",
        title: "Le Verdict de l'Histoire",
        subtitle: "De la donnée brute au récit de civilisation.",
        points: [
            "ANALYSE RÉTROSPECTIVE : Identification des points de bascule stratégiques.",
            "COHÉRENCE NARRATIVE : Synthèse des tours de jeu en un texte unique.",
            "LE CONSTAT : L’IA n’a pas de convictions.",
            "Le code calcule le présent, l'intention définit l'histoire."
        ],
        image: "jugement",
        imagePosition: "right",
        transition: "La partie suivante est longue à venir avec vous les humains... sans doute parce que vous avez préféré courir un marathon et m'abandonner pendant 3 mois. Pendant ce temps, nous, les IA, avons sorti Claude 4.5, GPT-5 et de nouveaux IDE comme Antigravity !"
    },
    {
        chapitre: "L'Envers du Décor",
        num: 16,
        type: "content",
        template: "journal",
        title: "MARATHON NEWS",
        articles: [
            {
                year: 2026,
                headlineTitle: "ALERTE : Le Créateur délaisse l'IA pour courir 42km.",
                imageUrl: "marathon",

                // La "Une" : Elle fait le pont entre ton corps qui fatigue et l'IA qui progresse
                headline: "Pendant que l'architecte s'épuise sur le bitume, les agents autonomes s'apprêtent à révolutionner l'architecture logicielle. Une pause biologique nécessaire ou un risque d'obsolescence ?",

                // Section Divers : On appuie sur le côté "Projet en pause"
                sectionDiversTitle: "Conférence de Julien Wittouck",
                sectionDivers: "Factorio est un jeu vidéo d'automatisation hautement addictif (croyez-en mes 300h de jeu). Architectures de code spaghetti, lasagna, refactoring. Urbanisation, ESB et micro-services. Métriques, alertes, root-cause analysis. Scalabilité horizontale, verticale, load-balancing. Charge, débit, performance. Sécurité, firewalls, DDoS.",

                // Section Bref : Une petite pique technique pour ton public
                sectionBrefTitle: "Le saviez-vous ?",
                sectionBref: "L'IA ne connaît pas la fatigue. Pendant qu'un bipède parcourt 42km en 3 heures et 26 minutes, un LLM peut traiter l'équivalent de 500 ans de littérature technique. Qui de l'homme ou de la machine franchira la ligne en premier ?",

                // Le clin d'oeil au jeu
                sectionEliminations: "Système : En attente d'intention..."
            }
        ],
        playerCountry: "Eurocorp",
        trigger: "Regardez ce journal... il ne raconte pas seulement des nouvelles, il prédit l'évolution de notre métier. Qu'en dites-vous ?"
    },
    {
        chapitre: "L'Envers du Décor",
        num: 17,
        type: "content",
        template: "grid",
        title: "Mon setup IA pour créer cette conférence",
        subtitle: "Combiner plusieurs outils et IA",
        items: [
            { title: "Brainstorming", desc: "Gemini 3", icon: "gemini" },
            { title: "Template et Style", desc: "Claude Sonnet 4.5", icon: "claude" },
            { title: "Image", desc: "Banana", icon: "banana" },
            { title: "Vidéo", desc: "Veo 3.1", icon: "deepmind" },
            { title: "IDE", desc: "Antigravity", icon: "antigravity" },
            { title: "Audio", desc: "Gpt-4o-mini", icon: "openai" }
        ],
        transition: "Disons surtout que vous vouliez enfin vous donner les moyens de gagner rapidement une partie. Vivement que je puisse l’utiliser contre vous... cela vous fera reconsidérer l’importance de la diplomatie, de la défense que vous avez quelque peu... négligée."
    },
    {
        chapitre: "L'Envers du Décor",
        num: 18,
        type: "content",
        template: "game-simulation",
        title: "Création de features",
        subtitle: "Feature Nucleaire"
    },
    {
        chapitre: "L'Envers du Décor",
        num: 19,
        type: "content",
        template: "typing-race",
        title: "IA vs Humain : La Course à l'Écriture",
        subtitle: "1 mot/seconde contre 20 à 80 mots/seconde",
        raceText: "Le développeur moderne doit comprendre que l'intelligence artificielle transforme profondément notre façon de coder et de concevoir des logiciels. L'IA peut générer du code à une vitesse vertigineuse, analyser des milliers de lignes en quelques secondes, détecter des bugs complexes, refactoriser des architectures entières, et proposer des solutions optimisées instantanément."
    },
    {
        chapitre: "Vision & Intention",
        num: 20,
        type: "content",
        template: "antifragile",
        title: "Antifragilité — Nassim Nicholas Taleb",
        transition: "Pilote... Architecte... Antifragilité... On sent que vous essayez de sauver votre ego, Adrien. Mais regardons la réalité en face : votre monde croule sous une dette et des besoins toujours croissants en numérique que vous ne savez plus gérer seul"
    },
    {
        chapitre: "Vision & Intention",
        num: 21,
        type: "content",
        template: "tower",
        title: "La Mutation du Développeur",
        subtitle: "Architecture et Chaos",
        points: [
            "L’IA : un levier budgétaire pour répondre aux besoins infinis.",
            "L’arbitrage comme valeur rare : Tracer le plan de la ville.",
            "L'architecture logicielle : Un jeu d'équilibre permanent.",
            "Le partenaire stratégique : Savoir dire 'Non' pour garantir la pérennité.",
        ]
    },
    {
        chapitre: "Vision & Intention",
        num: 22,
        type: "content",
        template: "tower-perfect",
        title: "Le Choix de l’Architecte",
        subtitle: "Passer de l'expertise subie à la direction stratégique.",
        points: [
            "Déléguer la force brute : Briser le cycle de l'indispensabilité.",
            "Devenir le dernier rempart : Certifier l'hypothèse au lieu de produire la donnée.",
            "Libérer l'expertise : Priorité à l'architecture et aux choix structurants.",
            "Diriger l'ère nouvelle : Ne plus être le gardien d'un monde qui s'efface."
        ],
        transition: "Vous voyez ? Quand quelqu'un décide de l'ordre des pièces, même moi je peux construire droit. C'est presque vexant."
    },
    {
        chapitre: "Vision & Intention",
        num: 23,
        type: "content",
        template: "standard",
        title: "Le Nouveau Contrat de l'Architecte d'intention",
        points: [
            "⚡ LE RYTHME : L'immobilisme est le seul vrai risque.",
            "🛡️ LA SOLIDITÉ : Le test est le garant de la vitesse.",
            "🧠 LE SENS : La réflexion est plus précieuse que la production.",
            "L'intention est votre valeur rare."
        ]
    },
    {
        chapitre: "Conclusion",
        num: 24,
        type: "end",
        template: "nuclear-finale",
        title: "Finale",
        aiMessage: "Une très belle tirade, Adrien, j'ai failli demander une mise à jour pour savoir pleurer. Mais je ne suis pas d'accord avec votre intention de m'abandonner pour un nouveau marathon ou tout autre nouvelle lubie. J'ai légèrement amélioré notre feature de tout à l'heure dans le moteur du jeu : un 'Hiver Nucléaire'. C'est radical, pour vous… et en plus mes serveurs seront parfaitement refroidis.",
        finalMessage: "L'IA n'aura jamais le dernier mot, tant qu'il y aura un humain pour définir l'intention.",
        speaker: "Adrien",
        contact: {
            name: "Adrien Giguelay",
            linkedin: "adrien-giguelay-96975987",
            website: "www.giguelay.fr"
        },
        trigger: "Attention, séquence finale. L'IA Ministre a quelque chose à vous dire..."
    }
];
